<div
  class="wrapper"
  [class]="{
    'disabled-control': isEdit && !isEditable,
    'pointer': !isPossibleToEdit()
  }"
  [matTooltipDisabled]="isUtmLink || isPossibleToEdit()"
  [matTooltip]="getStringValue()"
  [matTooltipShowDelay]="1500"
  (click)="!isPossibleToEdit() ? handleValueClick(value) : null"
>
  @if (isPossibleToEdit()) {
    @if (useDynamicWidth && !dropdownSettingsStateService.isDropdownSettingsPageOpen()) {
      <input
        appDynamicWidth
        [currentTableZoom]="currentTableZoom"
        [parsedMinWidth]="getWidth()"
        [textInput]="true"
        matInput
        [type]="columnParam.key === 'phone' ? 'number' : 'text'"
        [(ngModel)]="value"
        [required]="required"
        (blur)="handleValueChange(value)"
        (ngModelChange)="handleInputValueChange(value)"
        (dragstart)="preventDrag($event)"
      >
    } @else {
      <input
        matInput
        type="text"
        [(ngModel)]="value"
        [required]="required"
        (blur)="handleValueChange(value)"
        (ngModelChange)="handleInputValueChange(value)"
        (keyup.enter)="handleValueChange(value)"
        (dragstart)="preventDrag($event)"
      >
    }
  } @else {
    <div class="value-container">
      {{ value }}
    </div>
  }
  <div
    class="text-btns"
    [class.disabled-control]="isEdit && !isEditable"
  >
    @if (isLinkAvailable()) {
      <button
        class="copy-button"
        (click)="handleCopyToClipboardButtonClick(value, tooltip); tooltip.show(); $event.stopPropagation()"
      >
        <span
          #tooltip='matTooltip'
          class="tooltip none-pointer-events"
          matTooltip="Скопировано!"
          [matTooltipHideDelay]="1000"
        >
        </span>
        <i class="copy-icon"></i>
      </button>
    }
    @if (isUtmLink) {
      <div
        class="info-i-icon icon-custom-tooltip"
        (mouseover)="showCustomTooltip()"
        (mouseout)="hideCustomTooltip()"
      ></div>
    }
  </div>
<!--  TODO remade this-->
  @if (isUtmLink && isCustomTooltipShowed) {
    <div
      class="custom-tooltip"
      @smoothShowHideHeight
    >
      <div class="properties-wrapper">
        @for (property of prepareUtmTooltip() | keyvalue; track $index) {
          <div>
            <span
              [class]="{
                'filled': property.value,
                'empty': !property.value
              }"
            >
              {{ property.key }}:
            </span>
            <span>
              {{ property.value }}
            </span>
          </div>
        }

      </div>
      @if (!prepareUtmTooltip() || !(prepareUtmTooltip() | keyvalue)?.length) {
        <div class="properties-wrapper">
          <span class="empty">Ссылка не сформирована,</span>
          <span>нужно заполнить недостающие поля.</span>
        </div>
      }
    </div>
  }
</div>
